<mat-dialog-content>
  <div class="modal__confirmation">
    <div class="modal__confirmation-inner">
      <h2 class="modal__confirmation-title" *ngIf="data.title">
        {{ data.title }}
      </h2>
      <div class="modal__confirmation-main">
        {{ data.content }}
      </div>
    </div>
    <div class="modal__confirmation-btns">
      <button class="btn gray" (click)="close(false)">Cancel</button>
      <button class="btn blue" (click)="close(true)">Ok</button>
    </div>
  </div>
</mat-dialog-content>
